import React, { useContext, useEffect } from 'react';
import { LinkContainer } from 'react-router-bootstrap';
import Divider from 'components/common/divider/divider';
import AppContext from 'contexts/appContext';
import './homePage.css';

export default function HomePage(props) {
  const { setAppArea } = useContext(AppContext);

  useEffect(() => {
    setAppArea(AppContext.Areas.Home, 'Home');
  }, [props.location]);

  return (
    <div className='container mt-2 mb-4'>
      <Divider text='Operations' size='lg'></Divider>
      <div className='d-flex flex-wrap justify-content-center'>
        <GridLink to='/SoftwareUpdate' title='Software Update' />
        <GridLink to='/BackofficeReports/Run' title='Backoffice Reports' />
        <GridLink to='/Menus' title='Menus' />
        <GridLink to='/Employees' title='Employees' />
      </div>

      <Divider text='Support' size='lg'></Divider>
      <div className='d-flex flex-wrap justify-content-center'>
        <GridLink to='/Dashboard' title='Dashboard' />
        <GridLink to='/Boarding/Wizard' title='Boarding' />
        <GridLink to='/Orders' title='Orders' />
        <GridLink to='/SiteManager' title='Manage Site' />
        <GridLink to='/SystemStatus' title='System Status' />
      </div>

      <Divider text='Account' size='lg'></Divider>
      <div className='d-flex flex-wrap justify-content-center'>
        <GridLink to='/Account/Manage' title='Manage Account' />
      </div>

      <Divider text='Employees' size='lg'></Divider>
      <div className='d-flex flex-wrap justify-content-center'>
        <GridLink to='/EmployeeList' title='Manage Employees' />
        <GridLink to='/TimeAndAttendance' title='Time And Attendance' />
      </div>
    </div>
  );
}

function GridLink(props) {
  return (
    <LinkContainer to={props.to}>
      <a className='home-grid-link rounded shadow' href={props.to}>
        {props.title}
      </a>
    </LinkContainer>
  );
}
